import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartTreasuryTabPure extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "category.categoryFamily.name")}
        pivots={["family", "tiers"]}
        showColumns={["family", "tiersAsClientAndCategory", "hiddenCommercial"]}
        showPagination={false}
        showDetails={true}
        showExtra={true}
      />
    );
  }
}

export default ChartTreasuryTabPure;
